<template>
  <div>
    <v-tabs
      ref="tabs"
      v-model="active"
    >
      <v-tab
        v-for="item in tabItems"
        :key="item.name"
        class="divider font-black"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <div
      v-if="loading"
      align="center" 
      justify="center"
    >
      <v-progress-linear
        indeterminate
        color="primary"
      />
    </div>
    <div v-else>
      <v-tabs-items
        v-model="active"
        style="background:transparent"
      >
        <v-tab-item>
          <v-autocomplete
            v-model="attendanceReport"
            label="Report Types"
            :items="reportTypes"
            item-text="name"
            class="pt-5 px-3"
            autofocus
            style="background:white"
          />
          <report-attendance-attendance-detail-report
            v-if="attendanceReport === 'Monthly Detail Attendance Report'"
            :employees="employees"
            :departments="departments"
            :companies="companies"
            class="mb-2"
          />
          <report-attendance-attendance-summary-report
            v-if="attendanceReport === 'Attendance Summary By Employee Report'"
            :employees="employees"
            :departments="departments"
            :companies="companies"
            class="mb-2"
          />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
  export default {
    components: {
      ReportAttendanceAttendanceDetailReport: () => import('@/components/hris/reports/attendance/AttendanceDetailReport'),
      ReportAttendanceAttendanceSummaryReport: () => import('@/components/hris/reports/attendance/AttendanceSummaryReport'),
    },

    data () {
      return {
        tabItems: [
          { name: 'Attendance Reports' },
        ],
        active: 0,
        employees: [],
        departments: [],
        companies: [],
        loading: false,
        attendanceReport: null,
        reportTypes: [
          { name: 'Monthly Detail Attendance Report' },
          { name: 'Attendance Summary By Employee Report' },
        ],
        appOrg: process.env.VUE_APP_ORG,
      }
    },
    created () {
      this.loading = true

      Promise.all([
        this.$api.employees().list('?with=attendance_report'),
        this.$api.hrisDepartments().list(['name'], false, true),
        this.$api.hrisCompanies().list('?organization=' + this.appOrg),
      ])
        .then(([employees, departments, companies]) => {
          let temp = employees.data.filter(employee => {
            return employee.department_id !== null
          })

          this.employees = _.orderBy(temp, ['person.name'], ['asc'])
          this.departments = departments.data
          this.companies = _.orderBy(companies.data, ['name'], ['asc'])

          if (!this.$hasPermissionTo(['view departments'])) {
            const employeeDepartmentIds = new Set(this.employees.map(employee => employee.department_id))

            this.departments = this.departments.filter(department => employeeDepartmentIds.has(department.id))
          }
          
          if (!this.$hasPermissionTo(['view companies'])) {
            const companyUids = new Set()

            this.employees.forEach(employee => {
              const activeCompany = employee.company_employees.find(ce => ce.is_active_pay_status === 1)
              if (activeCompany) {
                companyUids.add(activeCompany.company_uid)
              }
            })

            this.companies = this.companies.filter(company => companyUids.has(company.id))
          }

          this.loading = false
        })
    },
  }
</script>
